import React from 'react';
import { render } from 'react-dom';
import './index.scss';
import * as serviceWorker from './serviceWorker';
// ? Routes
import { BrowserRouter as Router } from 'react-router-dom'
import AppRouter from './shared/routes/AppRoutes'
import { Provider } from 'react-redux'
import configureStore from './shared/redux/configureStorage'


import { PersistGate } from 'redux-persist/integration/react'

import 'bootstrap/dist/css/bootstrap.css'
import 'react-toastify/dist/ReactToastify.min.css'
import 'antd/dist/antd.css';

// const store = configureStore({})
const { persistor, store } = configureStore()

const rootElement = document.getElementById('root')
render(
  <Provider store={store} >
    <PersistGate loading={null} persistor={persistor}>
      <Router>
        <AppRouter />
      </Router>
    </PersistGate>
  </Provider>
  , rootElement);

serviceWorker.unregister();
